import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { RequestPerformanceRecordDto, RequestPerformanceSearchDto, RequestPerformanceRecordEmailDto, ResponseReportSendEmailDto } from "../dto/performance-report.dto";

@Injectable()
export class PerformanceReportApi {
    private service: string = '';
    private model: string = 'PerformanceAdmin';

    constructor(
        private nestApiProvider: NestApiProvider) {
    }

    preview() {
    }

    downloadExcel(data: RequestPerformanceRecordDto) {
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: RequestPerformanceRecordDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    downloadPdf(data: RequestPerformanceRecordDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: RequestPerformanceRecordDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    reportSendEmailExcel(data: RequestPerformanceRecordEmailDto): Observable<ResponseReportSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestPerformanceRecordEmailDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseReportSendEmailDto>(method, url, params, urlParams, body);
    }

    public reportSendEmailPdf(data: RequestPerformanceRecordEmailDto): Observable<ResponseReportSendEmailDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: RequestPerformanceRecordEmailDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseReportSendEmailDto>(method, url, params, urlParams, body);
    }

    getPeriodList(data: RequestPerformanceSearchDto): Observable<any> {
        const method: string = 'GET';
        const func: string = 'getPublishedAppraisal';
        const params: RequestPerformanceSearchDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request(method, url, func, params, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/performance-report.api.ts